import InterestRateLayout from '../../views/interestRate/payDayLoanInterestRate/Index'
import InterestRateList from '../../views/interestRate/payDayLoanInterestRate/List'
import InterestRateEdit from '../../views/interestRate/payDayLoanInterestRate/Edit'
import InterestRateCreate from '../../views/interestRate/payDayLoanInterestRate/Create'
import InterestRateShow from '../../views/interestRate/payDayLoanInterestRate/Show'
import Permissions from '@/permissions'

export const paydayInterestRateRouters = {
  path: 'pay-day-interest-rate',
  component: InterestRateLayout,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.interestRate.payDay.manage],
    groups: 'payday-interest-rate'
  },
  children: [
    {
      path: '',
      name: 'InterestRate',
      component: InterestRateList,
      meta: {
        permissions: [Permissions.backend.interestRate.payDay.list],
        groups: 'payday-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Payday Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីប្រចាំថ្ងៃ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'edit/:id',
      name: 'InterestRateEdit',
      component: InterestRateEdit,
      meta: {
        permissions: [Permissions.backend.interestRate.payDay.list],
        groups: 'payday-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Payday Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីប្រចាំថ្ងៃ'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'create',
      name: 'InterestRateCreate',
      component: InterestRateCreate,
      meta: {
        permissions: [Permissions.backend.interestRate.payDay.list],
        groups: 'payday-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Payday Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីប្រចាំថ្ងៃ'
          },
          {
            name_en: 'Create',
            name_km: 'បង្កើត'
          }
        ]
      }
    },
    {
      path: 'show/:id',
      name: 'InterestRateShow',
      component: InterestRateShow,
      meta: {
        permissions: [Permissions.backend.interestRate.payDay.list],
        groups: 'payday-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Payday Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីប្រចាំថ្ងៃ'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
